import { ListItem } from "@mui/material";
import { SxProps } from "@mui/system";
import { useCallback } from "react";
import { NameIdOption } from "../../../../../common/types/commonTypes";
import AutocompleteBase from "../autocompleteBase/AutocompleteBase";
import { handleAutocompleteChange } from "../helpers";
import useRecruitmentAreasAutocomplete from "./useRecruitmentAreasAutocomplete";

interface Props {
  value?: NameIdOption[];
  onChange?: (recruitmentAreas: NameIdOption[] | null) => void;
  multiple?: boolean;
  disabled?: boolean;
  fullWidth?: boolean;
  size?: "small" | "medium";
  limitTags?: number;
  sx?: SxProps;
}

const RecruitmentAreasAutocomplete = ({
  value,
  onChange,
  multiple = true,
  disabled = false,
  fullWidth = true,
  size = "small",
  limitTags,
  sx = {},
}: Props) => {
  const { recruitmentAreaOptions, isLoading } =
    useRecruitmentAreasAutocomplete();

  const handleChange = useCallback(
    (newValue: NameIdOption | NameIdOption[] | null) => {
      handleAutocompleteChange(newValue, onChange, multiple);
    },
    [onChange, multiple],
  );

  const getOptionLabel = (option: NameIdOption) => option.name;
  const isOptionEqualToValue = (option: NameIdOption, val: NameIdOption) =>
    option.id === val.id;

  return (
    <AutocompleteBase<NameIdOption>
      value={value || []}
      onChange={(newValue) => handleChange(newValue)}
      options={recruitmentAreaOptions}
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={isOptionEqualToValue}
      multiple={multiple}
      fullWidth={fullWidth}
      disabled={disabled}
      limitTags={limitTags}
      size={size}
      loading={isLoading}
      renderOption={(props, option) => (
        <ListItem {...props} key={option.id}>
          {option.name}
        </ListItem>
      )}
      sx={sx}
    />
  );
};

export default RecruitmentAreasAutocomplete;
